import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env.");
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storageKey: "kapio-auth",
    autoRefreshToken: true,
    persistSession: true,
    // Needed so Supabase parses the `#access_token=...&type=recovery` hash
    // coming from a password-reset email link and fires PASSWORD_RECOVERY.
    // Without this, ResetPassword has no session and updateUser() fails with
    // "Auth session missing!".
    detectSessionInUrl: true,
    flowType: "implicit",
    lock: async (_name, _timeout, fn) => fn(),
  },
});
